import type { FC, SVGProps } from "react";

interface IndoorMapThumbnailProps extends SVGProps<SVGSVGElement> {
  theme?: "light" | "dark";
}

/**
 * Generic indoor floor plan thumbnail background.
 * Supports light and dark themes.
 */
export const IndoorMapThumbnail: FC<IndoorMapThumbnailProps> = ({ theme = "light", ...props }) => {
  const backgroundColor = theme === "dark" ? "#252525" : "#F1F1F1";
  const strokeColor = theme === "dark" ? "#353535" : "#D9D9D9";

  return (
    <svg fill="none" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="1080" height="1080" fill={backgroundColor} />
      <path d="M390 100H218H304L304 617L248 617H359.5" stroke={strokeColor} strokeWidth="20" />
      <path d="M607 100H435H521L521 617L465 617H576.5" stroke={strokeColor} strokeWidth="20" />
      <path d="M739 199V479.5V385H950.5" stroke={strokeColor} strokeWidth="20" />
      <path d="M952 801H739V616.5" stroke={strokeColor} strokeWidth="20" />
      <path d="M574.5 801H251.5H413V974.5" stroke={strokeColor} strokeWidth="20" />
      <path d="M129 393.5L129 100H951.5V820.5" stroke={strokeColor} strokeWidth="20" />
      <path d="M130.5 699L130.5 980H951.5V806.5" stroke={strokeColor} strokeWidth="20" />
    </svg>
  );
};
